import Component from '@bythepixel/component-loader';
import GlideSlider from '../base';

const glideOptions = {
  type: 'carousel',
  startAt: 0,
  perView: 1,
  gap: 0,
  autoplay: 4000,
};

const selectors = {
  slideSelector: '[data-hero-slider="slide"]',
  slideIndicatorSelector: '[data-hero-slider-indicator]',
  slideIndicatorActiveClass: 'glide__bullet--active',
};

export default class SectionHeroSlider extends Component {
  static selector = '[data-comp-hero-slider]';
  static loaderPriority = 'in-view';

  constructor(containerEl) {
    super(containerEl);
    this.slider = new GlideSlider(containerEl, glideOptions, selectors);
    this.sliderGlideInstance = this.slider.getGlideSlider();

    // Run this event before transitioning the slide
    this.sliderGlideInstance.on(['mount.after', 'run.before'], () => {
      this.slider.handleSlideIndicatorActiveState();
    });

    this.sliderGlideInstance.mount();
  }
}
